import React from 'react';
import { useTranslations } from 'next-intl';

export default function NotAvailableItems({ energy = false }) {
  const t = useTranslations();

  return (
    <div className="w-full rounded-xl bg-[#1F233F] p-5">
      <p className="text-xs">{t('no_available_items')}</p>
      {energy ? (
        <span className="text-xs">{t('please_try_again_later_energy')}</span>
      ) : (
        <span className="text-xs">{t('please_try_again_later')}</span>
      )}
    </div>
  );
}
